const DOWNLOAD_ZTC_CONFIG_FILE = 'DOWNLOAD_ZTC_CONFIG_FILE';
const DOWNLOAD_ZTC_CONFIG_FILE__OK = 'DOWNLOAD_ZTC_CONFIG_FILE__OK';
const DOWNLOAD_ZTC_CONFIG_FILE__FAIL = 'DOWNLOAD_ZTC_CONFIG_FILE__FAIL';
const UPLOAD_ZTC_CONFIG_FILE = 'UPLOAD_ZTC_CONFIG_FILE';
const UPLOAD_ZTC_CONFIG_FILE__OK = 'UPLOAD_ZTC_CONFIG_FILE__OK';
const UPLOAD_ZTC_CONFIG_FILE__FAIL = 'UPLOAD_ZTC_CONFIG_FILE__FAIL';
export function request_ztc_config_file(device_id, service_password) {
    return async function (dispatch, getState, { api, comet }) {
        dispatch({ type: DOWNLOAD_ZTC_CONFIG_FILE, device_id });
        try {
            const response = await api.request_config_file(device_id, service_password);
            dispatch({
                type: 'APPLY_FILETRANSFER_UPDATE',
                device_id,
                transfer: response.transfer,
            });
            comet.listen({
                once: true,
                event: 'filetransfer_update',
                condition: {
                    device_id,
                    transfer: {
                        id: response.transfer.id,
                        done: true,
                    },
                },
                callback(msg) {
                    let config_content_id = null;
                    for (const [filename, content_id] of Object.entries(msg.transfer.content_ids ?? [])) {
                        config_content_id = content_id;
                        break;
                    }
                    if (config_content_id != null) {
                        dispatch({
                            type: DOWNLOAD_ZTC_CONFIG_FILE__OK,
                            device_id,
                        });
                        window.location.href = api.get_url('download_config_file', {
                            device_id,
                            content_id: config_content_id,
                        }, true);
                    }
                    else {
                        dispatch({
                            type: DOWNLOAD_ZTC_CONFIG_FILE__FAIL,
                            device_id,
                            error: 'filetransfer_failed',
                        });
                    }
                },
            });
        }
        catch (error) {
            const { json } = error;
            dispatch({
                type: DOWNLOAD_ZTC_CONFIG_FILE__FAIL,
                device_id,
                error: json?.error != null
                    ? json?.error
                    : 'Не удалось отправить запрос на сервер',
            });
        }
    };
}
export function upload_ztc_config_file(device_id, service_password, config_file) {
    return async function (dispatch, getState, { api }) {
        dispatch({ type: UPLOAD_ZTC_CONFIG_FILE, device_id });
        try {
            await api.upload_config_file(device_id, service_password, config_file);
            dispatch({ type: UPLOAD_ZTC_CONFIG_FILE__OK, device_id });
        }
        catch (error) {
            const { json } = error;
            dispatch({
                type: UPLOAD_ZTC_CONFIG_FILE__FAIL,
                device_id,
                error: json?.error ?? 'unknown_error',
            });
        }
    };
}
const initial_state = {
    by_device_id: {},
};
const per_device_initial = {
    loading: false,
};
function per_device_reducer(state = per_device_initial, action) {
    switch (action.type) {
        case DOWNLOAD_ZTC_CONFIG_FILE:
        case UPLOAD_ZTC_CONFIG_FILE:
            return { loading: true };
        case DOWNLOAD_ZTC_CONFIG_FILE__OK:
        case UPLOAD_ZTC_CONFIG_FILE__OK:
            return { loading: false, ok: true };
        case DOWNLOAD_ZTC_CONFIG_FILE__FAIL:
        case UPLOAD_ZTC_CONFIG_FILE__FAIL:
            return { loading: false, ok: false, error: action.error };
        default:
            return state;
    }
}
export function reducer(state = initial_state, action) {
    switch (action.type) {
        case DOWNLOAD_ZTC_CONFIG_FILE:
        case DOWNLOAD_ZTC_CONFIG_FILE__OK:
        case DOWNLOAD_ZTC_CONFIG_FILE__FAIL:
        case UPLOAD_ZTC_CONFIG_FILE:
        case UPLOAD_ZTC_CONFIG_FILE__OK:
        case UPLOAD_ZTC_CONFIG_FILE__FAIL:
            return {
                by_device_id: {
                    ...state.by_device_id,
                    [action.device_id]: per_device_reducer(state.by_device_id[action.device_id], action),
                },
            };
        default:
            return state;
    }
}
